import AuthUser from "./models/auth-user.entity";
import storageService from "../services/storage.service";
import axios from "axios";
import whitelabelService from "../services/whitelabel/whitelabel.service";
import themeConfig from "../services/whitelabel/whitelabel-infos";

class AuthService {
  private isProductionDomain(): boolean {
    const { host } = window.location;
    const subdomain = host.split('.')[0];

    const themeItem = themeConfig
      .find(item => item.workspace === subdomain);

    return !!themeItem;
  }

  public getToken = async () => {
    const whitelabelCompany = whitelabelService.getWBDataCompany();

    if (this.isProductionDomain()) {
      return axios.get(`${process.env.REACT_APP_ENVIROMENT}/infovist/bb-user`, {
        params: {
          apiToken: whitelabelCompany.api,
          domain: whitelabelCompany.workspace,
        },
      }).then((response) => ({ token: response.data.token }));
    } else {
      return axios.post(`${process.env.REACT_APP_API_URL}/v1/auth/login`, {
        email: process.env.REACT_APP_AUTH_EMAIL,
        password: process.env.REACT_APP_AUTH_PASSWORD,
        api_token: process.env.REACT_APP_API_TOKEN,
      }).then((response) => ({ token: response.data.data.access_token }));
    }
  }

  public saveAuth = (user: AuthUser): void => {
    storageService.setObject('token', btoa(JSON.stringify(user)));
  };

  public getAuth = (): AuthUser => {
    const base64Auth = storageService.getObject('token');
    let user: AuthUser = new AuthUser();
    if (base64Auth) {
      const authStr = atob(base64Auth);
      user = new AuthUser(JSON.parse(authStr));
    }

    return user;
  };
}
export default new AuthService();
